import { useBloc as useBlocNext } from "@blac/react";
import type { FC } from "react";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AssumeIdentityHandoverCubit, {
  readExchangeCode
} from "src/state/AssumedIdentityCubit/AssumeIdentityHandoverCubit";
import { NiceError } from "src/ui/styled/NiceError";
import Loader from "../Loader/Loader";

const AssumeIdentityHandover: FC = () => {
  const [state, { redeem }] = useBlocNext(AssumeIdentityHandoverCubit);
  const { hash, pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const code = readExchangeCode(hash);
    // Drop the code from the address bar and history before anything can log or share it.
    navigate({ pathname, search }, { replace: true });
    void redeem(code);
  }, []);

  if (state.status === "failed") {
    return (
      <NiceError>
        <h1>Could not open the member app</h1>
        <p>{state.reason}</p>
      </NiceError>
    );
  }

  return <Loader active fixed absolute fullPage />;
};

export default AssumeIdentityHandover;
